var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-header clear-filter"},[_c('parallax',{staticClass:"page-header-image",staticStyle:{"background-image":"url('/assets/image/bg/bg_19.png')"}}),_c('download-app-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }